var app = angular.module('directives.feedback');

app.directive('feedback', ['PortalApi', 'Authentication', 'Notification', '$translate', 'Localization', feedback]);

function feedback(PortalApi, Authentication, Notification, $translate, Localization) {
    return {
        restrict: 'EA',
        template: require('../templates/index.html'),
        link: postLink
    };

    function postLink($scope, el, attrs, controller) {
        $scope.form = {
            isClient: false,
            responseType: 0,
            replySwitch: false,
            subjectType: '0'
        };
        $scope.activeTab = '';
        $scope.subjectType = '0';
        $scope.activeButt = '';
        $scope.isLogged = Authentication.isLogged;
        $scope.preLoader = false;
        $scope.agreed = true;

        $scope.init = function () {
            $scope.activeButt = '';
            $scope.isLogged = Authentication.isLogged;
            $scope.preLoader = false;
            $scope.agreed = true;
            $scope.form = {
                isClient: false,
                responseType: 0,
                replySwitch: false,
                subjectType: '0'
            };
        };

        $scope.init();

        $scope.changeResponseType = function () {
            $scope.form.responseType = '1';
        };

        $scope.changeSubjectType = function () {
        };

        $scope.setActiveLink = function (index) {
            $scope.activeLink = index;
        };

        $scope.setTab = function (tabName) {
            $scope.activeTab = $scope.activeTab !== tabName ? tabName : '';
            $scope.init();
        };

        $scope.submit = function (form) {

            if ($scope.activeLink == '') {
                Localization.notifyTemplate('error', 'NOTIFICATION.ERROR.MESSAGE_TYPE', 5, true);
            }

            if ($scope.agreed == false) {
                Localization.notifyTemplate('error', 'NOTIFICATION.ERROR.INFO_ACCESS', 5, true);
            }

            $scope.preLoader = true;
            $scope.form.subject = $scope.activeLink;

            PortalApi.feedback(form).then(function (response) {
                $scope.setTab();
                $translate(
                    'NOTIFICATION.SUCCESS.REGISTRATION_SUCCESS',
                    { fio: $scope.form.fio }
                ).then(function (translation) {
                    Notification({
                        message: translation,
                        delay: 7000
                    });
                });
            }, function () {

                Localization.notifyTemplate('error', 'NOTIFICATION.ERROR.SEND_NOTICE', 5, true);

            }).finally(function () {
                $scope.preLoader = false;
            });
        }
    }
}

module.exports = app;



/*****************
 ** WEBPACK FOOTER
 ** ./app/directives/feedback/directives/feedback.directive.js
 ** module id = 161
 ** module chunks = 1
 **/